import { ApiProperty } from "@nestjs/swagger";

export class AttnAdjustLogReq {
    @ApiProperty()
    employeeCode: string;

    @ApiProperty()
    date: string;

    @ApiProperty()
    inTime: Date;

    @ApiProperty()
    outTime: Date;

    @ApiProperty()
    presentStatus: string;

    @ApiProperty()
    reason: string;

    @ApiProperty()
    remarks: string;

    @ApiProperty()
    user: string
}